import { Link } from "react-router-dom";
import { prequalApi } from "../../api";
import { ProcError, ProcLoading, ProcPagination } from "../../components/ProcurementLayout";
import { useAsyncData, usePageState } from "../../hooks";

export default function PrequalListPage() {
  const { page, size, setPage, state } = usePageState();

  const { data, loading, error } = useAsyncData(
    () => prequalApi.list({ page: state.page, size: state.size }),
    [state.page, state.size],
  );

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Supplier Prequalifications</h1>
        </div>
        <Link to="/procurement/supplier-prequal/new" className="rounded-xl bg-emerald-700 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-800">
          New Prequalification
        </Link>
      </div>

      {loading && <ProcLoading />}
      {error && <ProcError message={error} />}

      {!loading && !error && data && (
        <>
          <div className="rounded-2xl border bg-white shadow-sm overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="bg-slate-50 text-xs uppercase text-slate-500">
                <tr>
                  <th className="px-4 py-3">Serial No</th>
                  <th className="px-4 py-3">Supplier Name</th>
                  <th className="px-4 py-3">Contact</th>
                  <th className="px-4 py-3 text-right">Tech Total/100</th>
                  <th className="px-4 py-3 text-center">Passed</th>
                  <th className="px-4 py-3">Date</th>
                  <th className="px-4 py-3 text-right">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {data.content.length === 0 && (
                  <tr><td colSpan={7} className="px-4 py-8 text-center text-slate-400">No prequalification records found.</td></tr>
                )}
                {data.content.map((r) => (
                  <tr key={r.id} className="hover:bg-slate-50">
                    <td className="px-4 py-3 font-mono font-semibold text-slate-900">{r.serialNo}</td>
                    <td className="px-4 py-3 text-slate-700">{r.supplierName}</td>
                    <td className="px-4 py-3 text-slate-600">{r.contactPerson}</td>
                    <td className="px-4 py-3 text-right font-semibold">{r.techTotal}</td>
                    <td className="px-4 py-3 text-center">{r.passed ? <span className="text-emerald-600 font-bold">✓</span> : <span className="text-red-500 font-bold">✗</span>}</td>
                    <td className="px-4 py-3 text-slate-500">{r.date ? new Date(r.date).toLocaleDateString() : "—"}</td>
                    <td className="px-4 py-3 text-right">
                      <Link to={`/procurement/supplier-prequal/${r.id}`} className="font-semibold text-emerald-700 hover:underline">View</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <ProcPagination
            page={data.number}
            totalPages={data.totalPages}
            totalElements={data.totalElements}
            onPage={setPage}
          />
        </>
      )}
    </div>
  );
}
